module.exports = __webpack_public_path__ + "static/media/bank-card-2-line.9bdf1d11.svg";